<template>
  <div>
    <div class="title">Follow us</div>
    <div class="mx-1">
      <a href="https://www.facebook.com/motionarray" target="_blank" rel="noopener noreferrer" class="mx-2 w-5 h-5">
        <i class="fab fa-facebook-f fa-lg icon"></i>
      </a>
      <a href="https://www.instagram.com/motionarray" target="_blank" rel="noopener noreferrer" class="mx-2 w-5 h-5">
        <i class="fab fa-instagram fa-lg icon"></i>
      </a>
      <a href="https://twitter.com/MotionArray" target="_blank" rel="noopener noreferrer" class="mx-2 w-5 h-5">
        <i class="fab fa-twitter fa-lg icon"></i>
      </a>
      <a href="https://www.youtube.com/c/MotionArrayTutorials" target="_blank" rel="noopener noreferrer" class="mx-2 w-5 h-5">
        <i class="fab fa-youtube fa-lg icon"></i>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "footer"
}
</script>

<style scoped>
.title {
  margin: 40px 16px 25px;
  text-transform: uppercase;
  font-size: 14px;
  line-height: 16px;
  @apply text-white;
}

.icon {
  @apply text-primary-beige;
}
</style>
